import React from "react";

const About = () => {
  return (
    <div className="about">
      <section>
        hi, my name is kevin. i use <strong>they/them</strong> pronouns. i am a multidisciplinary writer and tech worker.
      </section>
      <br />
      <section>
        i have written for publications such as{" "}
        <a className="paragraphLink" href="https://www.inheritancemag.com/">
          inheritance magazine
        </a>
        ,{" "}
        <a className="paragraphLink" href="https://aaww.org/the-margins/">
          the margins (aaww)
        </a>
        ,{" "}
        <a className="paragraphLink" href="https://www.greatriverreview.com/">
          the great river review
        </a>
        , amongst others. all of my writing can be found{" "}
        <a className="paragraphLink" href="/#/writing">
          here
        </a>
        .
      </section>
      <br />
      <section>
        i have most recently worked as a software engineer on the platform team at{" "}
        <a
          className="paragraphLink"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.tempus.com/"
        >
          tempus ai
        </a>{" "}
        – a precision medicine data platform focused primarily on oncology,
        neurology, and infectious disease.
      </section>
      <br />
      <section>
        previously, i have also worked as a software engineer at{" "}
        <a
          className="paragraphLink"
          target="_blank"
          rel="noopener noreferrer"
          href="https://livefeather.com"
        >
          feather
        </a>{" "}
        – a furniture rental company with the mission to keep furniture waste
        out of landfills towards realizing a more circular economy – and at{" "}
        <a
          className="paragraphLink"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.liveperson.com/"
        >
          liveperson
        </a>
        , a conversational commerce platform.
      </section>
      <br />
      <section>
        a more complete overview of my work history can be found{" "}
        <a
          className="paragraphLink"
          target="_blank"
          href="Software_Engineer_CV.pdf"
        >
          here
        </a>
        .
      </section>
    </div>
  );
};

export default About;
